import { EmailTemplate } from 'app/models/dto/email-template.model';

export class GetEmailTemplates {
	static readonly type = '[EmailTemplates] GetEmailTemplates';
	constructor() {}
}

export class CreateEmailTemplate {
	static readonly type = '[EmailTemplates] CreateEmailTemplate';
	constructor(public template: { title: string, subject: string, content: string }) {}
}

export class UpdateEmailTemplate {
	static readonly type = '[EmailTemplates] UpdateEmailTemplate';
	constructor(public template: EmailTemplate) {}
}

export class DeleteEmailTemplate {
	static readonly type = '[EmailTemplates] DeleteEmailTemplate';
	constructor(public templateId: number) {}
}

export class GetTemplateVariables {
	static readonly type = '[EmailTemplates] GetTemplateVariables';
	constructor() {}
}
